import { getConfig } from '@/js/helpers/config'
import { trackAmplitudeEvent } from '@/js/tools/amplitude'
import config from './amplitude/config.json'
import axios, { AxiosError, AxiosResponse } from 'axios'

const affiliate = (): void => {
  const appUrl = getConfig('BRIGHTERLY_APP_URL')
  if (!appUrl) throw new Error('appUrl is not defined')
  const searchParams = new URLSearchParams(window.location.search)
  const stringParams = searchParams.toString()
  if (stringParams) {
    const requestUrl = `${appUrl}/booking/simple/start?${stringParams}`
    axios.post(requestUrl, null, { withCredentials: true })
      .then((res: AxiosResponse): void => {
        trackAmplitudeEvent(config.events.requestSuccess, {
          name: 'affiliate_request',
          code: res?.status || null
        })
      })
      .catch((error: AxiosError): void => {
        trackAmplitudeEvent(config.events.requestError, {
          name: 'affiliate_request',
          code: error.code || null
        })
      })
  }
}

affiliate()
